import styled from 'styled-components';

export const Label = styled.span`
  color: ${(props) => {
    switch (props.type) {
      case 'FORMALIZATION':
        return props.theme.colors.brand.primary;
      case 'PENDING':
        return props.theme.colors.negative.primary;
      case 'RETENTION':
        return props.theme.colors.alert.primaryAlt;
      default:
        return '';
    }
  }};
`;
